export default "/_next/static/images/cat-toy 3x-f14f9907aa0f2ca31329a27a2eb32ea7.png";